// react
import { List, Map, Record } from "immutable";

// dependencies

// utils

// create a slideout record
const SlideoutRecord = Record({
	id: "",
	name: "",
});

const initialState = Map({
	openSlideouts: List(),
});

export default function slideouts(state = initialState, action) {
	switch (action.type) {
		case "SLIDEOUTS:OPEN": {
			const slideout = new SlideoutRecord({
				id: action.slideoutName,
				name: action.slideoutName,
			});
			return state.set("openSlideouts", state.get("openSlideouts").push(slideout));
		}

		case "SLIDEOUTS:CLOSE":
			return state.set(
				"openSlideouts",
				state.get("openSlideouts").filter((d) => d.get("id") !== action.slideoutIdentifier)
			);

		default:
			return state;
	}
}
